import { LabCanvas3D } from './LabCanvas3D';
import { type WaterBeakerState, createBeakerScene } from './waterBeakerScene';

export type { WaterBeakerState } from './waterBeakerScene';

/**
 * Real-world view of the heating model: a glass beaker on a hot plate with ice, refractive water,
 * boiling bubbles, steam and a thermometer. The particle box beside it shows the same sample zoomed in.
 */
export function WaterBeaker3D({ state, playing, label }: { state: WaterBeakerState; playing: boolean; label: string }) {
  return <LabCanvas3D build={createBeakerScene} state={state} playing={playing} label={label} hint="Drag to turn the beaker" />;
}
